import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { cardCls, inputCls, fmtDate } from "./ui";

export const SubscribersSection = () => {
  const [items, setItems] = useState([]);
  const [interestOptions, setInterestOptions] = useState([]);
  const [filters, setFilters] = useState({ status: "", interest: "", country: "" });

  const load = () =>
    api.get("/admin/subscribers", { params: filters }).then((r) => {
      setItems(r.data.items);
      setInterestOptions(r.data.interests);
    }).catch(() => {});

  useEffect(() => { load(); }, [filters.status, filters.interest]);

  return (
    <div data-testid="admin-subscribers-section">
      <div className="flex flex-wrap items-center gap-3 mb-5">
        <select value={filters.status} onChange={(e) => setFilters((f) => ({ ...f, status: e.target.value }))} data-testid="subs-status-filter" className={`${inputCls} w-44`}>
          <option value="">All</option>
          <option value="subscribed">Subscribed</option>
          <option value="unsubscribed">Unsubscribed</option>
        </select>
        <select value={filters.interest} onChange={(e) => setFilters((f) => ({ ...f, interest: e.target.value }))} data-testid="subs-interest-filter" className={`${inputCls} w-56`}>
          <option value="">All interests</option>
          {interestOptions.map((i) => <option key={i} value={i}>{i}</option>)}
        </select>
        <input placeholder="Country…" value={filters.country} onChange={(e) => setFilters((f) => ({ ...f, country: e.target.value }))} onKeyDown={(e) => e.key === "Enter" && load()} data-testid="subs-country-filter" className={`${inputCls} max-w-[180px]`} />
        <button onClick={load} className="bg-midnight text-white text-xs font-medium px-5 py-2.5 hover:bg-midnight-light">Apply</button>
      </div>

      <div className={`${cardCls} overflow-x-auto`}>
        <div className="hidden lg:grid grid-cols-12 gap-3 px-5 py-3.5 border-b border-midnight/10">
          {["Email", "Name / Company", "Country", "Interests", "Source", "Consent", "Status"].map((h, i) => (
            <span key={h} className={`text-[10px] font-bold uppercase tracking-[0.15em] text-midnight/40 ${["col-span-3", "col-span-2", "col-span-1", "col-span-3", "col-span-1", "col-span-1", "col-span-1"][i]}`}>{h}</span>
          ))}
        </div>
        {items.length === 0 && <p className="px-5 py-10 text-sm text-midnight/40">No subscribers yet.</p>}
        {items.map((s) => (
          <div key={s.id} className="grid grid-cols-2 lg:grid-cols-12 gap-3 items-center px-5 py-4 border-b border-midnight/[0.06]" data-testid={`subscriber-${s.id}`}>
            <span className="text-sm font-medium text-midnight lg:col-span-3 break-all">{s.email}</span>
            <span className="text-xs text-midnight/60 lg:col-span-2">{s.name}{s.company ? ` · ${s.company}` : ""}</span>
            <span className="text-xs text-midnight/55 lg:col-span-1">{s.country}</span>
            <span className="lg:col-span-3 flex flex-wrap gap-1">
              {(s.interests || []).slice(0, 3).map((i) => <span key={i} className="text-[10px] bg-midnight/[0.05] text-midnight/60 px-2 py-0.5">{i}</span>)}
              {(s.interests || []).length > 3 && <span className="text-[10px] text-midnight/40">+{s.interests.length - 3}</span>}
            </span>
            <span className="text-[11px] text-midnight/50 lg:col-span-1">{s.source}</span>
            <span className="text-[11px] text-midnight/50 lg:col-span-1" title={s.consent?.wording}>{fmtDate(s.consent?.ts)}</span>
            <span className={`text-[11px] font-bold lg:col-span-1 ${s.status === "subscribed" ? "text-emerald-600" : "text-midnight/35"}`}>
              {s.status === "subscribed" ? "ACTIVE" : "UNSUB"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
